
import { Server, Shield, Clock } from "lucide-react";

export const ChallengesSection = () => {
  return (
    <section className="py-16 bg-white" id="challenges">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-edgefi-purple/10 text-edgefi-purple rounded-full text-sm font-medium mb-4">Your IT Challenges</span>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            When Technology Holds You Back Instead of Propelling You Forward
          </h2>
          <p className="text-xl text-gray-600">
            You shouldn't have to worry about IT problems while trying to grow your business and serve your customers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div className="bg-gradient-to-br from-edgefi-white to-white p-6 rounded-xl border border-edgefi-purple/10 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1">
            <div className="mb-5 w-12 h-12 rounded-full bg-edgefi-purple/10 flex items-center justify-center">
              <Server className="h-6 w-6 text-edgefi-purple" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Disrupting Your Workflow</h3>
            <p className="text-gray-600">
              Your team's productivity suffers when systems go down, software updates fail, or tech issues interrupt your day. You need to focus on serving customers, not troubleshooting IT problems.
            </p>
          </div>

          <div className="bg-gradient-to-br from-edgefi-white to-white p-6 rounded-xl border border-edgefi-purple/10 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1" style={{ transitionDelay: "0.1s" }}>
            <div className="mb-5 w-12 h-12 rounded-full bg-edgefi-purple/10 flex items-center justify-center">
              <Shield className="h-6 w-6 text-edgefi-purple" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Security Keeps You Awake</h3>
            <p className="text-gray-600">
              Every headline about another data breach reminds you of your vulnerability. You wonder if your business is adequately protected, but finding and managing security expertise is challenging.
            </p>
          </div>

          <div className="bg-gradient-to-br from-edgefi-white to-white p-6 rounded-xl border border-edgefi-purple/10 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1" style={{ transitionDelay: "0.2s" }}>
            <div className="mb-5 w-12 h-12 rounded-full bg-edgefi-purple/10 flex items-center justify-center">
              <Clock className="h-6 w-6 text-edgefi-purple" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Unpredictable Costs</h3>
            <p className="text-gray-600">
              Unexpected IT expenses wreak havoc on your budget. Between emergency repairs, outdated hardware, and the constant cycle of software upgrades, planning your technology spending feels impossible.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
